import {enforce} from "vest";

export function numberGreaterThan(value: any, params: {number: number}) {
  enforce(value).message(JSON.stringify({message: 'validator.number_greater_than', params})).greaterThan(params.number);
}
